import { useCallback } from 'react';
import useWfDisasterRepo from '../repository/WfDisasterRepo';
import { useWfTyphoonStore } from '../stores/WfTyphoonStore';
import { WfTyphoon } from '../models/WfTyphoon';
import { useWfAlertHistoryStore } from '../stores/WfAlertHistoryStore';
import { useWfFilterStore } from '../stores/WfFilterStore';

const sanitizeTargetBranchIds = (targetBranchIds: string[], validBranchCodes: string[]) =>
  targetBranchIds.filter((branchCode) => validBranchCodes.includes(branchCode));

function useWfTyphoonService() {
  const { patchHistorySearchParams } = useWfAlertHistoryStore();
  const { setCurrentTyphoon } = useWfTyphoonStore();
  const { branchOptions } = useWfFilterStore();
  const { getDisasterLatestRequest, postDisasterRegisterRequest } = useWfDisasterRepo();

  const fetchLatestTyphoon = useCallback(async () => {
    await getDisasterLatestRequest().then((typhoon: WfTyphoon | null) => {
      setCurrentTyphoon(typhoon);
      patchHistorySearchParams({ disasterId: typhoon?.id ?? undefined });
    });
  }, [getDisasterLatestRequest, setCurrentTyphoon, patchHistorySearchParams]);

  const registerTyphoon = useCallback(
    async (
      typhoonName: string,
      targetBranchIds: string[],
      startDateTime: string,
      stopDateTime: string,
      disasterId?: string
    ) => {
      const response = await postDisasterRegisterRequest({
        typhoonName,
        targetBranchIds: sanitizeTargetBranchIds(
          targetBranchIds,
          branchOptions.map((branch) => branch.code)
        ),
        startDateTime,
        stopDateTime,
        ...(disasterId !== undefined && { disasterId }),
      });

      setCurrentTyphoon(response);
      return response;
    },
    [postDisasterRegisterRequest, setCurrentTyphoon, branchOptions]
  );

  return { fetchLatestTyphoon, registerTyphoon };
}

export default useWfTyphoonService;
